"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement("hr", { className: "md-block-hr" });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/medium-draft/lib/components/blocks/break.js
// module id = 185
// module chunks = 0